import { createSelector } from 'reselect';
import ViewTransactionHistoryColumns from '../../containers/ViewTransactionHistoryColumns';
import ViewTransactionHistoryTotalColumns from '../../containers/ViewTransactionHistoryTotalColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.TRANSACTION_HISTORY.isLoading;
export const getData = TableDefinitions.TRANSACTION_HISTORY.getDataFunction();
export const getColumns = createSelector(getData, ViewTransactionHistoryColumns);

export const getTotalData = createSelector(
  getData,
  (data) => {
    if (!data.length) {
      return [];
    }
    let totalPreAdvised = 0;
    let totalConfirmed = 0;
    let totalObjected = 0;

    data.forEach((d) => {
      totalPreAdvised += d.quantityPreAdvised;
      totalConfirmed += d.quantityConfirmed;
      totalObjected += d.quantityObjected;
    });
    return [
      {
        name: 'Total',
        quantityPreAdvised: totalPreAdvised,
        quantityConfirmed: totalConfirmed,
        quantityObjected: totalObjected,
      },
    ];
  },
);
export const getTotalColumns = createSelector(getData, ViewTransactionHistoryTotalColumns);
